import styled from 'styled-components';

export const BannerContainer = styled.div`
  max-width: 100%;
  background-color: #fff;
  padding: 0 24px 0 30px;
  margin-bottom: 24px;
  border-radius: 10px;
  color: #4d4d4d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;

  .podemorarText {
    color: ${({ color }) => color};
  }

  .textContainer {
    width: max-content;
    display: flex;
    gap: 20px;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    justify-content: space-between;
  }
  .textContainer > div {
    display: flex;
    align-items: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;

    gap: 12px;
    .title-text {
      color: ${({ color }) => color};
    }
    p {
      font-size: 18px;
      color: #4d4d4d;
      margin: 0;
    }
  }
  .container-diana-download {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: max-content;
    gap: 16px;
  }

  @media (max-width: 840px) {
    margin: 8px 2px;
    border-radius: 8px;
    flex-direction: column;
    padding: 24px;
    padding-bottom: 0px;
    justify-content: center;
    gap: 16px;

    .textContainer {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;

      p {
        text-align: center;
        font-size: 14px;
        margin: 2px;
      }
    }

    .container-diana-download {
      width: 100%;
    }
  }
`;

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  span {
    height: 50px;
    width: 2px;
    display: block;
    background-color: #ffffff;
    margin: 0 16px;
  }
`;

export const LojasContainer = styled.div`
  display: flex;
`;
